import { PauseCircleOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import React from 'react';

import { useEmailReplyT } from './emailReplyStrings';

interface Props {
  /** Resume AI is only offered to a user who may reply. */
  canResume: boolean;
  resuming: boolean;
  onResume: () => void;
}

/**
 * "AI replies paused on this thread": after a human reply on an AI (Case A)
 * thread the AI stops answering by itself until someone resumes it.
 */
const PausedStrip: React.FC<Props> = ({ canResume, resuming, onResume }) => {
  const { t } = useEmailReplyT();
  return (
    <Flex
      align='center'
      justify='space-between'
      gap={8}
      data-testid='ai-paused-strip'
      style={{
        margin: '0 0 12px',
        padding: '8px 12px',
        borderRadius: 8,
        border: '1px solid var(--gray-300)',
        background: 'var(--surface-container)',
        color: 'var(--text-primary)',
        fontSize: 12,
      }}
    >
      <Flex align='center' gap={8}>
        <PauseCircleOutlined style={{ color: 'var(--text-light)' }} />
        <span>{t('pausedTitle')}</span>
      </Flex>
      {canResume && (
        <Button size='small' loading={resuming} onClick={onResume}>
          {t('resumeAi')}
        </Button>
      )}
    </Flex>
  );
};

export default PausedStrip;
